var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCloudflareMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fbad41",
    d: "M132.234 32.698c-.552 0-1.097.02-1.641.037a.8.8 0 0 0-.256.06a.92.92 0 0 0-.593.64l-2.334 8.155c-1.006 3.506-.632 6.744 1.06 9.12c1.55 2.2 4.13 3.49 7.263 3.64l12.662.768c.376.02.702.2.9.5c.211.322.258.725.129 1.089a1.61 1.61 0 0 1-1.373 1.069l-13.157.768c-7.147.331-14.838 6.164-17.536 13.277l-.948 2.51a.703.703 0 0 0 .622.958h45.312a1.205 1.205 0 0 0 1.165-.878a33 33 0 0 0 1.204-8.885c0-18.12-14.529-32.808-32.459-32.808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6821f",
    d: "m112.457 74.235l.838-2.949c1.009-3.506.635-6.744-1.054-9.12c-1.556-2.2-4.134-3.49-7.268-3.64l-59.395-.768a1.17 1.17 0 0 1-.939-.5a1.24 1.24 0 0 1-.13-1.089a1.61 1.61 0 0 1 1.385-1.069l59.95-.768c7.117-.329 14.807-6.164 17.505-13.277l3.419-9.035a2.3 2.3 0 0 0 .1-1.197C122.973 13.199 107.392 0 88.764 0c-17.172 0-31.741 11.199-36.97 26.767A17.37 17.37 0 0 0 39.47 23.32c-8.232.828-14.858 7.534-15.676 15.857a18 18 0 0 0 .452 6.204C10.792 45.78 0 56.92 0 70.608c0 1.238.088 2.457.266 3.647c.073.577.565 1.01 1.147 1.009h109.688a1.43 1.43 0 0 0 1.356-1.05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCloudflareMark);
export default __webpack_public_path__ + "static/media/logo-cloudflare-mark.ac6d2afaea706346ad734aa708c39417.svg";
export { ForwardRef as ReactComponent };